import createDeviceFormModel from './createDeviceFormModel';

const {
  formField: {
    name,
    description,
    is_user_required,
    is_single_user,
    is_multi_user,
    users,
    all_users
  }
} = createDeviceFormModel;

const formInitialValues = {
  [name.name]: '',
  [description.name]: '',
  [is_user_required.name]: false,
  [is_single_user.name]: false,
  [is_multi_user.name]: false,
  [users.name]: [],
  [all_users.name]: false,
  logo_device: null,
  logo_quality: null,
  logo_device_preview: '',
  logo_quality_preview: ''
};

export default formInitialValues;
